import React from 'react';
import { Route } from 'react-router';

import Page from '../../components/Page';

import { LoadableNotFound } from './helpers/loadables';

export default (
  <>
    {/* Catch all route */}
    <Route component={Page}>
      <Route path="*" component={LoadableNotFound} status={404} />
    </Route>
  </>
);
